import { Box, IconButton, Stack, Typography } from 'src/components/mui';
import { X, ChevronLeft, Search } from 'lucide-react';

import { useMenuContext } from '../context';
import { EMenuOpenType } from '../types';

type Props = {
  onClose?: () => void;
  toggleSearchBar?: () => void;
  title?: string;
  handleBack?: () => void;
  isChild?: boolean;
};

export const Header = (props: Props) => {
  const { onClose, toggleSearchBar, title, handleBack, isChild } = props;
  const { colors, openType } = useMenuContext();
  const defaultTitle = openType === EMenuOpenType.BM ? title : 'IoT Menu';

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        px: 2,
        py: 0.5,
        width: '100%',
        backdropFilter: 'blur(10.5px)',
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1}>
        {isChild && (
          <IconButton onClick={handleBack} sx={{ color: colors.text }} size="small">
            <ChevronLeft size={16} />
          </IconButton>
        )}
        <Typography
          variant="h6"
          color={colors.text}
          sx={{
            textWrap: 'nowrap',
            overflow: 'hidden',
          }}
        >
          {defaultTitle}
        </Typography>
      </Stack>

      <Stack direction="row" alignItems="center" spacing={1} sx={{ color: colors.text }}>
        {!!toggleSearchBar && (
          <IconButton
            sx={{
              color: colors.search,
            }}
            onClick={toggleSearchBar}
          >
            <Search size={16} />
          </IconButton>
        )}
        {!!onClose && (
          <IconButton color="inherit" onClick={onClose}>
            <X size={20} />
          </IconButton>
        )}
      </Stack>
    </Box>
  );
};
